import React from "react";
import { View } from "react-native";
import { Display, mq } from "react-native-unistyles";

import Image from "$src/core/components/atoms/Image/Image";
import TvConnectButton from "$src/core/components/organisms/TvConnectButton";
import useLogo from "$src/core/hooks/use-logo";
import useTabBarHeight from "$src/core/hooks/use-tab-bar-height";
import DynamicPage from "$src/core/pages/DynamicPage/DynamicPage";

import $ from "./StorefrontPage.styles";

const StorefrontPage = () => {
  const logo = useLogo();
  const tabBarHeight = useTabBarHeight();

  return (
    <DynamicPage
      slug="storefront"
      HeroAccessory={
        <Display mq={mq.only.width(undefined, "lg")}>
          <>
            {/* We don't want to announce the logo */}
            {/* eslint-disable-next-line triple-rn-a11y/accessibility-label */}
            <Image
              source={logo}
              contentFit="contain"
              accessibilityRole="none"
              style={$.logo({ tabBarHeight })}
            />

            <View style={$.tvConnectButtonContainer({ tabBarHeight })}>
              <TvConnectButton />
            </View>
          </>
        </Display>
      }
    />
  );
};

export default StorefrontPage;
